import { render, staticRenderFns } from "./IdentityTestComponent.vue?vue&type=template&id=14d3f065"
import script from "./IdentityTestComponent.vue?vue&type=script&lang=js"
export * from "./IdentityTestComponent.vue?vue&type=script&lang=js"
import style0 from "./IdentityTestComponent.vue?vue&type=style&index=0&id=14d3f065&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports